<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item d-flex justify-content-center flex-column">
        <span v-if="user" class="text-uppercase text-dark font-weight-bold">{{
          user.name
        }}</span>
        <span v-if="user" class="text-lowercase text-sm">{{ user.email }}</span>
      </li>

      <li class="nav-item" v-if="$userCan(['administrator', 'supervisor', 'agent'])">
        <sidenav-collapse navText="Leads" :to="{ name: 'users' }">
          <template #icon>
            <office />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="$userCan('administrator')">
        <sidenav-collapse navText="Staff" :to="{ name: 'staff' }">
          <template #icon>
            <office />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="$userCan('administrator')">
        <sidenav-collapse
          navText="Notificaciones"
          :to="{ name: 'notifications' }"
        >
          <template #icon>
            <office />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="$userCan('administrator')">
        <sidenav-collapse navText="Logs / Trazabilidad" :to="{ name: 'audit-logs' }">
          <template #icon>
            <office />
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <a
      v-if="$userCan('administrator')"
      class="btn btn-outline-dark mb-2 w-100"
      @click="changePassword"
      type="button"
      >Cambiar contraseña</a
    >
    <a class="btn bg-gradient-success w-100" @click="logout" type="button"
      >Cerrar sesión</a
    >
  </div>
</template>
<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import Office from "../../components/Icon/Office.vue";
import { decrypt } from "@/utils/encrypt";
import routerList from "@/router/index";
import { get, post } from "@/utils/httpRequest";
export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data: () => ({
    title: "Pagos",
    controls: "",
    isActive: "active",
    arrayOptions: [
      { key: "dashboard", name: "" },
      "users",
      "transactions",
      "leads",
      "clients",
    ],
    arrayMenu: [],
    user_id: null,
    user: null,
  }),
  components: {
    SidenavCollapse,
    Office,
  },
  mounted() {
    this.getMenu();
    this.user_id = localStorage.getItem("shipping-admin-uuid");
    setTimeout(() => {
      this.getProfile();
    }, 500);
  },
  methods: {
    getMenu() {
      const storage = localStorage.getItem("shipping-admin-type");
      setTimeout(() => {
        const rol = decrypt(storage);
        const router = routerList.options.routes;
        this.arrayOptions.forEach((el) => {
          router.forEach((item) => {
            if (item.name === el) {
              if (item.meta.roles.includes(rol)) {
                this.arrayMenu.push(el);
              }
            }
          });
        });
      }, 500);
    },
    async getProfile() {
      const { data } = await get(`users/find-one?id=${this.user_id}`, null);
      data.password = "";
      this.user = data;
    },
    async changePassword() {
      this.$swal({
        title: "Actualizar contraseña de administrador",
        input: "password",
        inputLabel: "Nueva contraseña",
        inputPlaceholder: "Ingrese su nueva contraseña",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Actualizar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: async (password) => {
          if (!password || password.length < 3) {
            this.$swal.showValidationMessage(
              "La contraseña debe tener al menos 3 caracteres",
            );
            return false;
          }
          try {
            const { data } = await post(
              "users/update-admin-password",
              { password },
              true,
            );
            if (data && data.error) {
              this.$swal.showValidationMessage(
                data.message || "Error al actualizar la contraseña",
              );
              return false;
            }
            return data;
          } catch (error) {
            this.$swal.showValidationMessage(
              `Error en la petición: ${error.message || error}`,
            );
          }
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            icon: "success",
            html: "¡Contraseña actualizada correctamente!",
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
      });
    },
    logout() {
      localStorage.clear();
      this.$router.push("/");
    },
  },
};
</script>
